import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "manager-resident-detail" }
const _hoisted_2 = { class: "manager-resident-detail__header" }
const _hoisted_3 = { class: "manager-resident-detail__header-section" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "manager-resident-detail__header-section"
}
const _hoisted_6 = {
  type: "button",
  class: "manager-resident-detail__status-select"
}
const _hoisted_7 = { class: "manager-resident-detail__status-label" }
const _hoisted_8 = {
  key: 0,
  class: "manager-resident-detail__loading"
}
const _hoisted_9 = {
  key: 1,
  class: "manager-resident-detail__loading"
}
const _hoisted_10 = {
  key: 2,
  class: "general-information manager-resident-detail__content"
}
const _hoisted_11 = { class: "general-information__section" }
const _hoisted_12 = { class: "manager-resident-detail__general-content" }
const _hoisted_13 = {
  key: 0,
  class: "manager-resident-detail__logo"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "general-information__fields" }
const _hoisted_16 = { class: "field-with-label" }
const _hoisted_17 = { class: "field-with-label__value" }
const _hoisted_18 = { class: "field-with-label" }
const _hoisted_19 = { class: "field-with-label__value" }
const _hoisted_20 = { class: "field-with-label" }
const _hoisted_21 = { class: "field-with-label__value" }
const _hoisted_22 = { class: "field-with-label" }
const _hoisted_23 = { class: "field-with-label__value" }
const _hoisted_24 = { class: "field-with-label" }
const _hoisted_25 = { class: "field-with-label__value" }
const _hoisted_26 = { class: "field-with-label" }
const _hoisted_27 = { class: "field-with-label__value" }
const _hoisted_28 = { class: "field-with-label" }
const _hoisted_29 = { class: "field-with-label__value" }
const _hoisted_30 = { class: "field-with-label" }
const _hoisted_31 = { class: "field-with-label__value" }
const _hoisted_32 = { class: "field-with-label" }
const _hoisted_33 = { class: "field-with-label__value" }
const _hoisted_34 = { class: "field-with-label" }
const _hoisted_35 = { class: "field-with-label__value" }
const _hoisted_36 = { class: "field-with-label" }
const _hoisted_37 = { class: "manager-resident-detail__cluster-row" }
const _hoisted_38 = { class: "general-information__field-value general-information__field-value--cluster" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "general-information__section" }
const _hoisted_41 = { class: "general-information__fields" }
const _hoisted_42 = { class: "field-with-label" }
const _hoisted_43 = { class: "field-with-label__value" }
const _hoisted_44 = { class: "field-with-label" }
const _hoisted_45 = { class: "field-with-label__value" }
const _hoisted_46 = { class: "field-with-label" }
const _hoisted_47 = { class: "field-with-label__value" }
const _hoisted_48 = { class: "field-with-label" }
const _hoisted_49 = { class: "field-with-label__value" }

import { onMounted, ref, watch } from 'vue';
import type { MenuProps } from 'ant-design-vue';
import ArrowDownIcon from '@/js/components/icons/ArrowDownIcon.vue';
import {
  showStcErrorNotification,
  showStcSuccessNotification,
} from '@/js/components/stc-notification';
import { getAssetsPath } from '@/js/utils/getAssetsDir';
import ChangeClusterModal from './ChangeClusterModal.vue';
import {
  fetchManagerResidentDetail,
  updateManagerResidentCluster,
  updateManagerResidentStatus,
} from './manager-residents-api';
import type {
  ManagerResidentDetail,
  ManagerResidentRow,
  ManagerResidentsClusterOption,
} from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ResidentDetailView',
  props: {
    resident: {},
    clusters: {}
  },
  emits: ["back", "updated"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ? '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';
const EDIT_ICON = getAssetsPath('/assets/images/icons/share-icons/edit-icon.svg');

const loading = ref(false);
const error = ref('');
const detail = ref<ManagerResidentDetail | null>(null);
const clusterModalOpen = ref(false);
const clusterSaving = ref(false);
const statusSaving = ref(false);

function getStatusModifier(statusName: string): string {
  const normalized = statusName.toLowerCase();

  if (normalized.includes('актив')) return 'active';
  if (normalized.includes('исключ')) return 'excluded';
  if (normalized.includes('приостан') || normalized.includes('рассмотр')) return 'suspended';

  return 'default';
}

async function loadDetail() {
  loading.value = true;
  error.value = '';

  try {
    detail.value = await fetchManagerResidentDetail(
      props.resident.id,
      props.resident,
      props.clusters,
    );
  } catch (loadError) {
    detail.value = null;
    error.value =
      loadError instanceof Error ? loadError.message : 'Не удалось загрузить данные резидента';
  } finally {
    loading.value = false;
  }
}

const handleStatusChange: MenuProps['onClick'] = async ({ key }) => {
  if (!detail.value || statusSaving.value || String(key) === detail.value.status.id) {
    return;
  }

  statusSaving.value = true;

  try {
    const status = await updateManagerResidentStatus(detail.value.id, String(key));
    detail.value.status = status;
    emit('updated');
    showStcSuccessNotification('Статус резидента обновлён');
  } catch (updateError) {
    showStcErrorNotification(
      updateError instanceof Error ? updateError.message : 'Не удалось обновить статус',
    );
  } finally {
    statusSaving.value = false;
  }
};

async function handleClusterSelect(clusterId: string) {
  if (!detail.value || clusterSaving.value) return;

  clusterSaving.value = true;

  try {
    const result = await updateManagerResidentCluster(detail.value.id, clusterId, props.clusters);
    detail.value.clusterId = result.clusterId;
    detail.value.clusterName = result.clusterName;
    clusterModalOpen.value = false;
    emit('updated');
    showStcSuccessNotification('Кластер резидента обновлён');
  } catch (updateError) {
    showStcErrorNotification(
      updateError instanceof Error ? updateError.message : 'Не удалось обновить кластер',
    );
  } finally {
    clusterSaving.value = false;
  }
}

watch(
  () => props.resident.id,
  () => {
    void loadDetail();
  },
);

onMounted(() => {
  void loadDetail();
});

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "manager-resident-detail__back",
          "aria-label": "Вернуться к списку резидентов",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back')))
        }, [
          _createElementVNode("img", {
            src: `${_unref(ICONS_BASE)}/arrow-back-icon.svg`,
            alt: "",
            "aria-hidden": "true"
          }, null, 8, _hoisted_4)
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "manager-resident-detail__title" }, "Резидент", -1))
      ]),
      (detail.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
              overlay: _withCtx(() => [
                _createVNode(_component_a_menu, { onClick: handleStatusChange }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.statusOptions, (option) => {
                      return (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: option.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass(["manager-resident-detail__status-option", {
                    'manager-resident-detail__status-option--selected':
                      option.id === detail.value.status.id,
                  }])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["manager-resident-detail__status-dot", `manager-resident-detail__status-dot--${getStatusModifier(option.name)}`]),
                              "aria-hidden": "true"
                            }, null, 2),
                            _createElementVNode("span", null, _toDisplayString(option.name), 1)
                          ], 2)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_6, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["manager-resident-detail__status-dot", `manager-resident-detail__status-dot--${getStatusModifier(detail.value.status.name)}`]),
                    "aria-hidden": "true"
                  }, null, 2),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(detail.value.status.name), 1),
                  _createVNode(ArrowDownIcon, { class: "manager-resident-detail__status-icon" })
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Загрузка..."))
      : (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(error.value), 1))
        : (detail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("section", _hoisted_11, [
                _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "general-information__section-title" }, "Общее", -1)),
                _createElementVNode("div", _hoisted_12, [
                  (detail.value.logoUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("img", {
                          src: detail.value.logoUrl
                        }, null, 8, _hoisted_14)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "field-with-label__label" }, "Полное наименование", -1)),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(detail.value.fullName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "field-with-label__label" }, "Сокращенное название", -1)),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(detail.value.shortName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "field-with-label__label" }, "Описание проекта", -1)),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(detail.value.projectDescription), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "field-with-label__label" }, "ИНН", -1)),
                      _createElementVNode("span", _hoisted_23, _toDisplayString(detail.value.inn), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "field-with-label__label" }, "ОГРН", -1)),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(detail.value.ogrn), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "field-with-label__label" }, "Юридический адрес", -1)),
                      _createElementVNode("span", _hoisted_27, _toDisplayString(detail.value.legalAddress), 1)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "field-with-label__label" }, "Фактический адрес", -1)),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(detail.value.actualAddress), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "field-with-label__label" }, "Email", -1)),
                      _createElementVNode("span", _hoisted_31, _toDisplayString(detail.value.email), 1)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "field-with-label__label" }, "Телефон", -1)),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(detail.value.phone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "field-with-label__label" }, "Сайт", -1)),
                      _createElementVNode("span", _hoisted_35, _toDisplayString(detail.value.website), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "field-with-label__label" }, "Кластер", -1)),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("p", _hoisted_38, _toDisplayString(detail.value.clusterName), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-medium btn-secondary",
                          "aria-label": "Изменить кластер",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (clusterModalOpen.value = true))
                        }, [
                          _createElementVNode("img", { src: _unref(EDIT_ICON) }, null, 8, _hoisted_39)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_40, [
                _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "general-information__section-title" }, "Контактное лицо", -1)),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "field-with-label__label" }, "ФИО", -1)),
                    _createElementVNode("span", _hoisted_43, _toDisplayString(detail.value.contact.fullName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "field-with-label__label" }, "Должность", -1)),
                    _createElementVNode("span", _hoisted_45, _toDisplayString(detail.value.contact.position), 1)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "field-with-label__label" }, "Телефон", -1)),
                    _createElementVNode("span", _hoisted_47, _toDisplayString(detail.value.contact.phone), 1)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "field-with-label__label" }, "Email", -1)),
                    _createElementVNode("span", _hoisted_49, _toDisplayString(detail.value.contact.email), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
    (detail.value)
      ? (_openBlock(), _createBlock(ChangeClusterModal, {
          key: 3,
          open: clusterModalOpen.value,
          "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((clusterModalOpen).value = $event)),
          "cluster-id": detail.value.clusterId,
          clusters: __props.clusters,
          saving: clusterSaving.value,
          onSelect: handleClusterSelect
        }, null, 8, ["open", "cluster-id", "clusters", "saving"]))
      : _createCommentVNode("", true)
  ]))
}
}

})